import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { Loading } from './flightDetail/loading'

const PrivateRoute = ({ component: Component, authed, isLoading, ...rest }) => {
    if (isLoading) {
        return (<Loading />)
    } else {
        return (
            <Route {...rest} render={(props) => (
                authed === true
                    ? <Component {...props} />
                    : <Redirect to={{
                        pathname: '/login',
                        state: { from: props.location }
                    }} />
            )} />)
    }
}

export default PrivateRoute